import { render, staticRenderFns } from "./combing.vue?vue&type=template&id=bfa77ec6&scoped=true&"
import script from "./combing.vue?vue&type=script&lang=js&"
export * from "./combing.vue?vue&type=script&lang=js&"
import style0 from "./combing.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"
import style1 from "./combing.vue?vue&type=style&index=1&id=bfa77ec6&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa77ec6",
  null
  
)

export default component.exports